import { render } from "./Bubble.vue?vue&type=template&id=aa5caa94&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=ts"
export * from "./Bubble.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-aa5caa94"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput,QSeparator});
